import PostAd from "../../components/PostAd";

const PostPage = () => {
  return (
    <div>
      <PostAd />
    </div>
  );
};

export default PostPage;
